import home from './home'
import about from './about'
import business from './business'
import solution from './solution'
import news from './news'
import welfare from './welfare'
import jobs from './jobs'
import dangjian from './dangjian'
import detail from './mobile-detail'
import intellectual from './intellectual'

export default [...home, ...about, ...business, ...solution, ...news, ...welfare, ...jobs, ...dangjian, ...detail, ...intellectual]
